<div class="member-card">
  <!-- card image -->
  <div class="member-card__img-container">
    <img
      class="card-img"
      [ngSrc]="
        cardData()?.profile_image?.cropped_url?.toLowerCase() ||
          cardData()?.profile_image?.url
          | imageSource: false : 'sm' : 'assets/images/no-profile-image.png'
      "
      width="88"
      height="88"
      priority
      [alt]="cardData().first_name" />
  </div>
  <!-- card content -->
  <div class="member-card__content">
    <!-- full name -->
    <h3 class="content-name">
      {{ cardData().first_name }} {{ cardData().last_name }}
    </h3>
    <!-- job -->
    <p class="content-role">{{ cardData().job_position | translateData }}</p>
    <!-- phone number -->
    @if (
      cardData()?.mobile?.mobile_number &&
      !cardData()?.mobile?.mobile_number?.includes('000000')
    ) {
      <p class="content-phone">
        {{ cardData()?.mobile?.prefix }}
        {{ cardData()?.mobile?.mobile_number }}
      </p>
    }
  </div>
  <!-- social media list -->
  @if (cardData()?.links && cardData().links.length > 0) {
    <ul class="ceo-section__right-box">
      @for (link of cardData()?.links; track link?.url) {
        @if (socialMediaConstant?.[link.type]) {
          <li>
            <a
              [href]="socialMediaConstant[link.type].prefixUrl + link.url"
              target="_blank">
              <img
                class="ceo-section__social-icon"
                [ngSrc]="socialMediaConstant[link.type].icon"
                width="26"
                height="26"
                [alt]="link.url" />
            </a>
          </li>
        }
      }
    </ul>
  }
</div>
